/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_TitleInputs */

const en_interview_prepare_title = /** @type {(inputs: Interview_Prepare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Interview Questions`)
};

const de_interview_prepare_title = /** @type {(inputs: Interview_Prepare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewfragen generieren`)
};

const fr_interview_prepare_title = /** @type {(inputs: Interview_Prepare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer des questions d'entretien`)
};

const es_interview_prepare_title = /** @type {(inputs: Interview_Prepare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar preguntas de entrevista`)
};

const it_interview_prepare_title = /** @type {(inputs: Interview_Prepare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera domande per il colloquio`)
};

const nl_interview_prepare_title = /** @type {(inputs: Interview_Prepare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer sollicitatievragen`)
};

const pl_interview_prepare_title = /** @type {(inputs: Interview_Prepare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj pytania rekrutacyjne`)
};

const fi_interview_prepare_title = /** @type {(inputs: Interview_Prepare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo haastattelukysymyksiä`)
};

const da_interview_prepare_title = /** @type {(inputs: Interview_Prepare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer interviewspørgsmål`)
};

const sv_interview_prepare_title = /** @type {(inputs: Interview_Prepare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera intervjufrågor`)
};

/**
* | output |
* | --- |
* | "Generate Interview Questions" |
*
* @param {Interview_Prepare_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_title = /** @type {((inputs?: Interview_Prepare_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_title(inputs)
	if (locale === "fr") return fr_interview_prepare_title(inputs)
	if (locale === "es") return es_interview_prepare_title(inputs)
	if (locale === "it") return it_interview_prepare_title(inputs)
	if (locale === "nl") return nl_interview_prepare_title(inputs)
	if (locale === "pl") return pl_interview_prepare_title(inputs)
	if (locale === "fi") return fi_interview_prepare_title(inputs)
	if (locale === "da") return da_interview_prepare_title(inputs)
	if (locale === "sv") return sv_interview_prepare_title(inputs)
	return en_interview_prepare_title(inputs)
});